export default "__VITE_ASSET__DrBaI8sm__"